import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFieldTypeByTypeID } from 'reduxStore/types/selectors';
import { DatePicker, Input, InputNumber, Select, Typography } from 'zui/Antd';

const { Option } = Select;
const { Text } = Typography;

const EditableDeviceField = ({ fieldTypeID, value, disabled = false, onChange, onChangeInput }) => {
	const type = useSelector((state) => selectFieldTypeByTypeID(state, fieldTypeID))?.name || 'String';
	
	// Local state for input fields to handle user typing
	const [localValue, setLocalValue] = useState(value);
	
	// Sync local state with prop value when it changes externally (e.g., from modal update)
	useEffect(() => {
		setLocalValue(value);
	}, [value]);

	const handleInputChange = (newValue) => {
		setLocalValue(newValue);
		if (onChange) {
			onChange(newValue);
		}
	};

	const handleCommit = (newValue) => {
		if (onChangeInput) {
			onChangeInput(newValue);
		}
	};

	if (type === 'String' || type === 'VideoLink') {
		return (
			<Input
				value={localValue}
				placeholder={type === 'VideoLink' ? 'https://…' : 'Enter Value'}
				style={{ width: '100%' }}
				onChange={(e) => handleInputChange(e.target.value)}
				onBlur={(e) => handleCommit(e.target.value)}
				onPressEnter={(e) => handleCommit(e.target.value)}
				disabled={disabled}
			/>
		);
	}

	if (type === 'Number') {
		return (
			<InputNumber
				value={localValue}
				placeholder='Enter Value'
				style={{ width: '100%' }}
				onChange={(number) => handleInputChange(number)}
				onBlur={() => handleCommit(localValue)}
				onPressEnter={() => handleCommit(localValue)}
				disabled={disabled}
			/>
		);
	}

	if (type === 'Date') {
		return (
			<DatePicker
				value={localValue ? dayjs(localValue) : null}
				format='DD/MM/YYYY'
				style={{ width: '100%' }}
				onChange={(date) => {
					const isoValue = date ? date.toISOString() : null;
					setLocalValue(isoValue);
					onChange(isoValue);
				}}
				disabled={disabled}
			/>
		);
	}

	if (type === 'Boolean') {
		// Helper function to convert value to select options
		const getValueSelect = (value) => {
			if (value === true || value === 'true' || value === 1 || value === '1') return 'yes';
			if (value === false || value === 'false' || value === 0 || value === '0') return 'no';
			return undefined;
		};

		return (
			<Select
				value={getValueSelect(value)}
				placeholder='Select'
				style={{ width: '100%' }}
				onChange={(val) => onChange(val === 'yes')}
				disabled={disabled}
			>
				<Option value='yes'>Yes</Option>
				<Option value='no'>No</Option>
			</Select>
		);
	}

	return <Text>Unsupported field type</Text>;
};

export default EditableDeviceField;
